import commonGetters from '@/store/data/common/getters'
import { isEmpty } from 'lodash'

const getters = {
    getSimpleDspList: (_state, _getters, rootState) => () => {
        const _dspList = rootState.data.dsp.list
        const dspList = []

        if (!isEmpty(_dspList)) {
            for (const dsp of _dspList) {
                dspList.push({ label: dsp.label, id: dsp.id, keyLabel: dsp.keyLabel })
            }
        }
        return dspList
    }
}

export default { ...commonGetters, ...getters }
